(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blocks-slider-dynamic-reviews"] && !Shopify.designMode) return;
  try {
    
    (function() {
        var section = document.querySelector('[data-recommendations]');
        if (!section) return;

        var productId = section.dataset.productId;
        var limit     = section.dataset.limit || 4;
        var sectionId = section.dataset.sectionId;

        var url =
        '/recommendations/products?section_id=' + sectionId +
        '&product_id=' + productId +
        '&limit=' + limit;

        fetch(url)
        .then(function(res) { return res.text(); })
        .then(function(html) {
            var parser = new DOMParser();
            var doc    = parser.parseFromString(html, 'text/html');
            var inner  = doc.querySelector('.product-recommendations');
            if (inner) section.innerHTML = inner.innerHTML;
        });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-toc-v1"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class IngredientsSection {
      constructor(el) {
        this.section = el;
        if (this.section.dataset.ingInitialized === 'true') return;
        this.section.dataset.ingInitialized = 'true';

        this.navBtns = el.querySelectorAll('[data-ing-nav-btn]');
        this.blocks = el.querySelectorAll('[data-ing-block]');

        if (!this.navBtns.length || !this.blocks.length) return;

        this.initNav();
        this.initCarousels();
        this.initObserver();
      }

      initNav() {
        // All blocks stay visible - navigation only updates button states
        this.navBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            const targetId = btn.dataset.target;
            const target = document.getElementById(targetId);
            
            // Update button states
            this.navBtns.forEach((b) => {
              b.classList.remove('is-active');
              b.setAttribute('aria-pressed', 'false');
            });
            
            // Activate clicked button and scroll to target
            if (target) {
              btn.classList.add('is-active');
              btn.setAttribute('aria-pressed', 'true');
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });
        });
      }

      setActive(blockId) {
        this.navBtns.forEach((btn) => {
          const active = btn.dataset.target === `ing-block-${blockId}`;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      initObserver() {
        const headerHeight = parseInt(
          getComputedStyle(document.documentElement).getPropertyValue('--site-visible-header-height') || '0',
          10
        );

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.setActive(entry.target.dataset.ingBlock);
            });
          },
          {
            rootMargin: `-${headerHeight + 32}px 0px -55% 0px`,
            threshold: 0,
          }
        );

        this.blocks.forEach((block) => this.observer.observe(block));
      }

      initCarousels() {
        this.section.querySelectorAll('[data-ing-carousel]').forEach((carousel) => {
          const track = carousel.querySelector('[data-ing-track]');
          const nextBtn = carousel.querySelector('[data-ing-next]');

          if (!track || track.dataset.ingLoopReady === 'true' || track.children.length === 0) return;

          const originals = Array.from(track.children);
          if (originals.length < 2) {
            carousel.classList.add('ing-v1__carousel--static');
            if (nextBtn) nextBtn.hidden = true;
            return;
          }

          track.dataset.ingLoopReady = 'true';
          originals.forEach((item) => item.dataset.ingOriginal = 'true');

          // Prepend clones (in reverse to preserve order) and append clones
          // Layout: [clones-before] [originals] [clones-after]
          // Starting at clones-before width puts user on originals — seamless in both directions
          originals.forEach((item) => {
            const c = item.cloneNode(true);
            c.setAttribute('aria-hidden', 'true');
            track.appendChild(c);
          });
          originals.forEach((item) => {
            const c = item.cloneNode(true);
            c.setAttribute('aria-hidden', 'true');
            track.appendChild(c);
          });

          const getItemWidth = () => {
            const item = track.querySelector('.ing-v1__product');
            if (!item) return 220;
            return item.offsetWidth + (parseFloat(getComputedStyle(track).gap) || 12);
          };

          const getOriginalsWidth = () => originals.length * getItemWidth();

          // Start positioned on the originals (skip past the prepended clones)
          let ready = true;

          // Seamless loop: jump silently when entering clone territory
          let pending = false;
          track.addEventListener('scroll', () => {
            if (!ready || pending) return;
            const ow = getOriginalsWidth();
            if (track.scrollLeft >= ow) {
              // Scrolled into right clones → jump back to originals
              pending = true;
              track.scrollLeft -= ow;
              requestAnimationFrame(() => { pending = false; });
            }
          }, { passive: true });

          nextBtn?.addEventListener('click', () => {
            track.scrollBy({ left: getItemWidth(), behavior: 'smooth' });
          });
        });
      }
    }

    const initIngredientsSections = (scope = document) => {
      scope.querySelectorAll('.ing-v1').forEach((el) => new IngredientsSection(el));
    };

    initIngredientsSections();

    document.addEventListener('shopify:section:load', (event) => {
      initIngredientsSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
